export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'

export const USER_LOGOUT = 'USER_LOGOUT'


export const USER_REPUR_REQUEST = 'USER_REPUR_REQUEST'
export const USER_REPUR_SUCCESS = 'USER_REPUR_SUCCESS'
export const USER_REPUR_FAIL = 'USER_REPUR_FAIL'

export const USER_LIVREUR_REQUEST = 'USER_LIVREUR_REQUEST'
export const USER_LIVREUR_SUCCESS = 'USER_LIVREUR_SUCCESS'
export const USER_LIVREUR_FAIL = 'USER_LIVREUR_FAIL'

export const USER_CLIENT_REQUEST = 'USER_CLIENT_REQUEST'
export const USER_CLIENT_SUCCESS = 'USER_CLIENT_SUCCESS'
export const USER_CLIENT_FAIL = 'USER_CLIENT_FAIL'